// MODEL : instance of FieldFilter
//
define('app/filters/controls/InFilterControl',['require','glu/itemView','app/visualizations/FormatFactory','glu/util','hbs!./InFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		_ = require('glu/util');

	return ItemView.extend({
		template: require('hbs!./InFilterControl.hbs'),
		tagName: 'span',
		events: {
			'change [name=value]': 'updateModel',
			'keyup [name=value]': 'updateModel'
		},

		serializeData: function() {
			return this;
		},

		initialize: function() {
			this.model.clearArity();
		},

		onRender: function() {
			this.$('.select-box').comboBox();
		},


		selectedLabels: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});
			return _.map(this.selectedValues(), function(v) {
				return format(v);
			});
		},

		selectedValues: function() {
			return this.model.getValues() || [];
		},

		possibleValues: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});

			var possibleValues = this.model.possibleValues();
			// if the field has enumeration use the enumeration as possible values
			if (!_.isEmpty(this.model.enumeration())) {
				possibleValues = _.keys(this.model.enumeration());
			}

			return _.map(possibleValues, function(v) {
				return {
					value: v,
					label: format(v)
				};
			});
		},

		selectableOptions: function() {
			var selectedValues = this.selectedValues();
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: selectedValues.indexOf(pv.value) !== -1
				});
			});

			return selectableOptions;
		},

		updateModel: function() {
			this.model.setValues(this.$el.find('[name=value]').val());
		},

		isLoading: function() {
			return this.model.isFetchingConstraints();
		},

		hasSelectableOptions: function() {
			var optionsLength = this.selectableOptions();
			if (this.model.getDisplayFormat() === 'time') {
				return optionsLength.length > 0;
			} else {
				return optionsLength.length > 0 && optionsLength.length <= 1000;
			}
		}
	});

});

